import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalButtons,
  Button,
  Typography,
} from 'pvs-design-system';

interface DeleteResourceModalProps {
  open: boolean;
  resourceTitle?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteResourceModal: React.FC<DeleteResourceModalProps> = ({
  open,
  resourceTitle,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal open={open} onClose={onCancel} ariaLabelledby="delete-resource-title">
      <ModalHeader title="Delete Resource" onClose={onCancel} />
      <ModalContent>
        <Typography variant="p-md">
          Delete <strong>{resourceTitle}</strong>? This cannot be undone.
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ModalButtons>
          <Button variant="text" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm}>
            Delete
          </Button>
        </ModalButtons>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteResourceModal;
